module.exports = __webpack_public_path__ + "static/media/au.9b18ee04.svg";